module.exports = __webpack_public_path__ + "static/media/5a Overhook.18aea0eb.jpg";